import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Cropper from 'cropperjs';


@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit, OnDestroy {

  @ViewChild('imageCropper', {static: true}) imageCropper: ElementRef;
  cropper: Cropper;
  hideImageCropper = true;
  isPurchaseOrder: boolean;


  constructor(
    private dialogRef: MatDialogRef <ImageCropperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {image: string, isShow: boolean}
    // @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.isPurchaseOrder = data.isShow;
    console.log('imgScr=>', data);
    
  }

  resetCrop(): void {
    this.imageCropper.nativeElement.src = this.data.image;
    this.hideImageCropper = true;
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper.clear();
      this.cropper = null;
    }

  }

  onSaveClick(): void {
    this.dialogRef.close(this.cropper.getCroppedCanvas({
      width: 200,
      height: 200,
      minWidth: 160,
      minHeight: 160,
      maxWidth: 400,
      maxHeight: 400,
      // fillColor: '#fff',
      // imageSmoothingEnabled: true,
      // imageSmoothingQuality: 'low',
    }));
  }

  ngOnInit() {
    this.resetCrop();
    this.cropper = new Cropper(this.imageCropper.nativeElement, {
      responsive: true,
      aspectRatio: 1,
      viewMode: 2,
      rotatable: true
    });
  }
  ngOnDestroy(): void {
    this.cropper.destroy();
  }

}
